import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Feedback from "./FeedbackFom";

function SubmitForm() {
  const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div
        className="d-flex align-items-center justify-content-center"
        // style={{ height: "100vh" }}
      >
        <Button variant="primary" onClick={handleShow}>
          FILL OUT THE FORM
        </Button>
      </div>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-center">  FILL OUT THE FORM</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Feedback />
        </Modal.Body>
        <Modal.Footer>
          {/* <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Save Changes
          </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default SubmitForm;